import { useEffect, useState } from "react";
import { api } from "./api";

export type IngestedMarkers = { past: Set<string>; coc: Set<string> };
const NONE: IngestedMarkers = { past: new Set(), coc: new Set() };

/** Ids of past exams and COC exams created by ingestion, for the "Ingested" label. Empty while loading or if the admin cannot read it. */
export function useIngestedMarkers(token: string | null | undefined): IngestedMarkers {
  const [ids, setIds] = useState<IngestedMarkers>(NONE);
  useEffect(() => {
    if (!token) return;
    let live = true;
    api.admin.ingestReview
      .created(token)
      .then((r) => { if (live) setIds({ past: new Set(r.past_exams), coc: new Set(r.coc_exams) }); })
      .catch(() => {});
    return () => { live = false; };
  }, [token]);
  return ids;
}
